import { useState, useEffect } from 'react'
import { fontColorForBackground } from '../utils/colors'
import { getColor } from '../utils/bike-schema'
import { formatCurrencyAlwaysSign } from '../utils/money'
import { t } from '../utils/i18n'

const CurrentUniqueRals = ({
  choices,
  onSelect,
  activeRal,
  currencyCode,
  priceDiffForRal
}) => {
  const [uniqueRals, setUniqueRals] = useState([])

  useEffect(() => {
    setUniqueRals(listUniqueRals(choices))
  }, [choices])

  const listUniqueRals = (choices) => {
    let unique = []
    if (choices) {
      choices.forEach(({ ral }) => {
        if (ral) unique.push(ral)
      })
    }
    return [...new Set(unique)]
  }

  return (
    <div>
      <div data-ral="Q" className="velorbis-customizer-ral-picker-color head">
        {t('current_colors')}:
      </div>
      {uniqueRals.map((ral) => {
        const priceDiff = priceDiffForRal ? priceDiffForRal(ral) : 0
        return (
          <div
            key={ral}
            className="velorbis-customizer-ral-picker-color"
            style={{
              backgroundColor: getColor(ral).hex,
              color: fontColorForBackground(getColor(ral).hex)
            }}
            data-ral={`Q${ral}`}
            onClick={() => onSelect(ral)}
          >
            <div className="velorbis-customizer-ral-picker-color-name">
              RAL {ral}: {getColor(ral).name}
              {priceDiff !== 0 && (
                <span className="velorbis-customizer-ral-picker-color-price">
                  {formatCurrencyAlwaysSign(priceDiff, currencyCode)}
                </span>
              )}
              {activeRal === ral && (
                <div className="velorbis-customizer-ral-picker-color-selected">
                  {t('selected')}
                </div>
              )}
            </div>
          </div>
        )
      })}
      <div className="velorbis-customizer-ral-picker-separator__with-spacing" />
    </div>
  )
}

export default CurrentUniqueRals
